<div [innerHTML]="svgContent"></div>
